import { render, staticRenderFns } from "./ChangeStatusToDoneDialog.vue?vue&type=template&id=35cb11da"
import script from "./ChangeStatusToDoneDialog.vue?vue&type=script&lang=ts"
export * from "./ChangeStatusToDoneDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports